import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { EXPERTISE_STATS, CERTS } from '../data/catalog';

const KEYS = Object.keys(CERTS);

const Expertise = () => {
  const [active, setActive] = useState('ms');
  const group = CERTS[active];

  return (
    <section className="band band-line" id="expertise">
      <div className="wrap">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow-dark">Company Expertise</span>
          <h2>Certifications and credentials behind our delivery</h2>
          <p>
            Our consulting team holds active, current certifications across Microsoft, AWS, and Google
            Cloud, backed by enterprise architecture (TOGAF) and delivery (PMP) credentials &mdash; the
            expertise base behind every engagement.
          </p>
        </motion.div>

        <div className="stat-row">
          {EXPERTISE_STATS.map((s) => (
            <div className="stat" key={s.lbl}>
              <div className="num">{s.num}</div>
              <div className="lbl">{s.lbl}</div>
            </div>
          ))}
        </div>

        <div className="cert-tabs">
          {KEYS.map((k) => (
            <button
              key={k}
              className={`cert-tab-btn ${active === k ? 'active' : ''}`}
              onClick={() => setActive(k)}
            >
              {CERTS[k].label}
            </button>
          ))}
        </div>

        <motion.div key={active} className="cert-grid" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
          {group.items.map((c, i) => (
            <div className="cert-badge" key={`${c.name}-${i}`}>
              <div className={`cert-swatch ${group.swatch}`}>{c.code}</div>
              <div>
                <div className="cert-name">{c.name}</div>
                <div className="cert-issuer">{c.issuer}</div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Expertise;
